import { render, staticRenderFns } from "./BlogCategoryList.vue?vue&type=template&id=3121edb4&scoped=true&"
import script from "./BlogCategoryList.vue?vue&type=script&lang=js&"
export * from "./BlogCategoryList.vue?vue&type=script&lang=js&"
import style0 from "./BlogCategoryList.vue?vue&type=style&index=0&id=3121edb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3121edb4",
  null
  
)

export default component.exports